require('./_wks-define')('observable');


//////////////////
// WEBPACK FOOTER
// ./~/.2.4.1@core-js/library/modules/es7.symbol.observable.js
// module id = 244
// module chunks = 0